<script lang="ts">
  import { page } from '$app/stores';
  import Image from '$lib/components/Shared/Image.svelte';
  import { timeAgo } from '$lib/utils';
  import { createNewsDetailsUrl } from '$lib/utils/news';
  import { utm_medium } from '../../../routes/us-elections/store/nav';
  import Share from '../Shared/Share.svelte';

  export let heroImage: string;
  export let bgColor = '#ffffff';
  export let postId: string;
  export let headline: string;
  export let priority = false;
  export let category: string;
  export let showShare = true;
  export let publisherName = '';
  export let publishDate = '';
  export let ctaUrl = '';
  export let handleClick: () => void;

  const url = createNewsDetailsUrl(category, postId);

  const hrefHandler = () => {
    if (ctaUrl && $page.url.pathname.includes(noNavRoutes)) {
      const queryString = `utm_source=g&utm_medium=${$utm_medium}&sr=Glance&gpid=$GPID&sdkv=$BUILD_VERSION&gl_imp_id=$IMP_ID`;
      return `${ctaUrl}?${queryString}`;
    }
    return url;
  };

  const noNavRoutes = '/us-elections';
</script>

<article class="news-article">
  <a href={hrefHandler()} class="news-article-link" on:click={handleClick}>
    <div class="image-container" style="--bg-color: {bgColor}">
      <Image src={heroImage} alt={headline} {priority} />
    </div>
    <div class="news-content" class:show-share={!showShare}>
      {#if publisherName}
        <div class="publisher-name">
          {publisherName.toUpperCase()}
          <div class="dot" />
          {timeAgo(publishDate)}
        </div>
      {/if}
      <h3 class="title text-limit">{headline}</h3>
      {#if showShare}
        {#if !$page.url.pathname.includes(noNavRoutes)}
          <div class="icons-container">
            <slot />
            <Share {url} />
          </div>
        {/if}
      {/if}
    </div>
  </a>
</article>

<style lang="scss">
  .news-article {
    padding: 12px 0;
  }

  .news-article-link {
    text-decoration: none;
    display: flex;
  }

  .image-container {
    position: relative;
    background-color: var(--bg-color);
    border-radius: 16px;
    overflow: hidden;
    height: 78px;
    max-width: 78px;
  }

  .news-content {
    margin-left: 16px;
    display: flex;
    align-items: start;
    flex-direction: column;
    width: 100%;
    justify-content: space-evenly;
  }

  .title {
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-semibold);
    line-height: 130%;
    color: var(--color-title);
    margin: 0;
  }

  .text-limit {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-break: break-word;
  }

  .icons-container {
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    margin-top: 8px;
    margin-right: 20px;
  }

  .publisher-name {
    text-decoration: none;
    color: var(--color-text-secondary);
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 200% */
    opacity: 0.5;
    display: flex;
    align-items: center;
  }

  .show-share {
    margin-bottom: 10px;
  }

  .dot {
    width: 3px;
    height: 3px;
    background: var(--color-white);
    opacity: 0.5;
    border-radius: 50%;
    margin: 0px 4px;
  }
</style>
